import * as userRequest from "@/utils/userRequest";

export default async function getSettingDepositAndWithdraw(
    onSuccess?: (data?: any) => any,
    handleError?: (err?: any) => any
) {
    try {
        const res = await userRequest.get("/payment-gateway/setting-deposit-and-withdraw");

        if (res.success) {
            onSuccess && onSuccess(res.data);
            return res.data;
        }
    } catch (err) {
        console.error("🚀 ~ getSettingDepositAndWithdraw ~ err:", err);
        handleError && handleError(err);
        throw err;
    }
}
